import { clerk } from "@/lib/auth";
import { queryClient } from "@/query-client";
import { routeTree } from "@/routeTree.gen";
import { ClerkProvider } from "@clerk/clerk-react";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/ui/theme-provider/theme-provider";

const router = createRouter({ routeTree });

function App() {
  return (
    <ClerkProvider publishableKey={clerk.PUBLISHABLE_KEY}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider storageKey="flash-theme">
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
}

export default App;
